<template>
  <div class="distribution pad15">
    <div class="overflow mar10-b bg-white radius10 pad15">
      <div class="arial text-center">
        <span class="f40 fb blue">{{ info.recommendRewardNum || 0 }}</span>
        <span class="f16 pad5-l pad10-r pad10-t" @click="getInfo">
          <van-icon name="question-o" />
        </span>
      </div>
      <div class="text-center gray mar20-b">累计收益（积分）</div>
      <div class="flex flex-item1 items-center relative pad15-lr mar15-b overdiv">
        <div class="item">
          <div class="flex mar10-b">
            <span class="f13 gray flex-auto">今日预估</span>
            <span class="arial f14">
              {{ info.todayPointNum || 0 }}
            </span>

          </div>
          <div class="flex">
            <span class="f13 gray flex-auto">本月预估</span>
            <span class="arial f14">
              {{ info.monthPointNum || 0 }}
            </span>
          </div>
        </div>
        <div class="mar15-lr"></div>
        <div class="item">
          <div class="flex mar10-b">
            <span class="f13 gray flex-auto">本周预估</span>
            <span class="arial f14">
              {{ info.weekPointNum || 0 }}
            </span>
          </div>
          <div class="flex">
            <span class="f13 gray flex-auto">本年预估</span>
            <span class="arial f14">
              {{ info.yearPointNum || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white gray6 radius10 pad15 f13">
      <div class="gray3 f14">收益订单</div>
      <div class="pad15-tb flex justify-around list-class">
        <div
          v-for="(item, index) in statusList"
          class="radius30 pad15-lr item"
          :key="index"
          :class="{ active: item.id === orderStatus }"
          @click="statusChange(item.id)"
        >
        <!-- @click="rankClassChange(index)" -->
          {{ item.name }}
        </div>
      </div>
      <div class="flex list-wrap fb">
        <div class="list-item">买家</div>
        <div class="list-item">订单金额</div>
        <div class="list-item">返利积分</div>
        <div class="list-item">订单状态</div>
      </div>
      <template v-if="list.length">
        <div class="list-wrap flex" v-for="item in list" :key="item.id">
          <div class="list-item text-overflow">{{ item.userName }}</div>
          <div class="list-item">{{ item.fMoney }}</div>
          <div class="list-item">{{ item.pointsNum }}</div>
          <div class="list-item">{{ item.orderStatus }}</div>
        </div>
      </template>
      <!-- v-if="listLoad && !list.length" -->
      <div v-else class="text-center pad30-t pad10-b">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast, Dialog } from "vant";

export default {
  data() {
    return {
      env: process.env,
      input: "",
      timeList: [],
      orderStatus: "",
      // 2:已支付,3:已发货,4:已收货
      statusList: [
        {
          id: "",
          name: "全部"
        },
        {
          id: 2,
          name: "已支付"
        },
        {
          id: 3,
          name: "已发货"
        },
        {
          id: 4,
          name: "已收货"
        }
      ],

      list: [],

      pageSize: 999,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,

      info: {},

      listLoad: false
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo
  }),
  created() {
    this.init();
    this.getList();
  },
  methods: {
    init() {
      // 累计
      this.$store
        .dispatch("channel/queryPointsByPtType", {
          type: 1,
          ptType: "RECOMMEND_REWARD_ADD_PT"
        })
        .then((data) => {
          const { recommendRewardNum } = data;
          this.info = {
            ...this.info,
            recommendRewardNum
          };
        });
      // 获取预估 （本年，本月，本周，今日）
      this.$store.dispatch("channel/queryRecommendPointsMap").then((data) => {
        const { yearPointNum, monthPointNum, todayPointNum, weekPointNum } = data;
        this.info = {
          ...this.info,
          yearPointNum,
          monthPointNum,
          todayPointNum,
          weekPointNum
        };
      });
    },
    getList() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true
      });
      this.listLoad = false;
      const { orderStatus, pageSize, pageNum } = this;
      this.$store
        .dispatch("channel/queryRecommendPointsOrderList", {
          orderStatus,
          pageSize,
          pageNum
        })
        .then((data) => {
          this.listLoad = true;
          console.log("订单", data);
          const { orderList, totalNum, totalPage } = data;
          const list = orderList || [];
          this.list = list;
          this.totalPage = totalPage;
          this.pageTotal = totalNum;
        }).finally(() => {
          Toast.clear();
        });
    },
    statusChange(id) {
      this.orderStatus = id;
      this.getList();
    },
    getInfo() {
      Dialog.alert({
        title: "温馨提示",
        message: "推荐返利积分是由您推荐的客户（旗舰店设置关系后）在农信数智官方旗舰店进行交易后，店铺返还给您的奖励，该积分在客户确认收货（交易完成）后自动发放，您可在积分所属的店铺进行采购抵扣货款。"
      });
    }
  },
  // 监听器
  filters: {}
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
